import React from "react";
import { motion } from "framer-motion";

const trust = [
  { k: "Licensure", v: "LMFT #122546 · California" },
  { k: "Modality", v: "Secure telehealth · HIPAA-compliant" },
  { k: "Serves", v: "California residents only" },
  { k: "Availability", v: "Evenings & weekends by request" },
];

const ease = [0.16, 1, 0.3, 1];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about"
      className="relative w-full py-28 sm:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10">
        <div className="flex items-baseline justify-between border-b border-[#D5D1C9] pb-6">
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#5C5C59]">
            (Ch. III) — About the practice
          </span>
          <span className="font-serif-display italic text-[#5C5C59]">dlg</span>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-8 lg:gap-14">
          {/* Portrait */}
          <div className="col-span-12 lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15%" }}
              transition={{ duration: 1, ease }}
              className="relative aspect-[3/4] w-full overflow-hidden border border-[#D5D1C9]"
            >
              <img
                src="https://images.pexels.com/photos/8260576/pexels-photo-8260576.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=780"
                alt="Two hands clasped in comfort"
                className="h-full w-full object-cover"
                draggable="false"
              />
              <div className="absolute left-4 top-4 bg-[#F7F5F0] px-3 py-1.5 font-sans-ui text-[10px] uppercase tracking-[0.28em] text-[#1A1A18] border border-[#D5D1C9]">
                Fig. 03 — Held
              </div>
            </motion.div>
            <p className="mt-4 font-sans-ui text-[12px] text-[#5C5C59] italic">
              What is welcomed can begin to move.
            </p>
          </div>

          {/* Text + credentials */}
          <div className="col-span-12 lg:col-span-7">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15%" }}
              transition={{ duration: 0.9, ease }}
              className="font-serif-display font-light tracking-tighter leading-[1] text-5xl sm:text-6xl lg:text-7xl"
            >
              A quieter kind of <em className="italic text-[#2C4C3B]">therapy</em>.
            </motion.h2>

            <div className="mt-10 grid grid-cols-12 gap-6">
              <p className="col-span-12 md:col-span-8 font-sans-ui text-[15px] sm:text-[16px] leading-relaxed text-[#5C5C59]">
                DLG Counseling &amp; Consulting is a small, California-based telehealth practice
                built around one belief: people don’t change by being fixed — they change by being
                understood. Sessions are unhurried, warm, and deeply confidential. You will not be
                a case number here.
                <br />
                <br />
                My work draws from attachment theory, emotionally focused therapy, and years spent
                sitting with couples and families in the actual middle of things. Whether you are
                navigating a first hard year, a long marriage that has grown quiet, or grief that
                arrived without warning — you are welcome.
              </p>

              <div className="col-span-12 md:col-span-4">
                <div className="border-t border-[#D5D1C9]">
                  {trust.map((t) => (
                    <div
                      key={t.k}
                      className="flex items-start justify-between gap-4 border-b border-[#D5D1C9] py-4"
                    >
                      <span className="font-sans-ui text-[10px] uppercase tracking-[0.28em] text-[#5C5C59]">
                        {t.k}
                      </span>
                      <span className="font-serif-display italic text-[#1A1A18] text-right leading-tight">
                        {t.v}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <a
                href="#book"
                data-testid="about-cta"
                className="inline-flex items-center gap-3 rounded-full bg-[#2C4C3B] px-6 py-3.5 text-[12px] uppercase tracking-[0.24em] text-[#F7F5F0] hover:bg-[#1E382A] active:scale-[0.98] transition-[background-color,transform] duration-200"
              >
                Request a free 15-min call →
              </a>
              <a
                href="tel:2096706799"
                data-testid="about-phone"
                className="link-under font-sans-ui text-[13px] uppercase tracking-[0.22em] text-[#1A1A18]"
              >
                209.670.6799
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
